import P2Medium from 'components/typography/P2Medium';
import { DepartmentRow } from 'components/tables/data/department/types';

/**
 * Column for the organization name.
 */
export default function OrganizationNameColumn({ data: { organization } }: { data: DepartmentRow }) {
  return <P2Medium color="gray.8">{organization.organizationName}</P2Medium>;
}
